import SettingsListItem from './settingsListItem';

export default SettingsListItem